export const Paths = {
    searchByCpf: `/customer-portal/v1/person/guardian`,
};